import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";
import { PLANNING_ENTITY_TYPES } from "../utils/planning";

const PLANNING_URL = `${API_BASE_URL}/planificacion`;
const VALID_ENTITY_TYPES = Object.values(PLANNING_ENTITY_TYPES);

async function planningFetch(url, options = {}, navigate) {
  const response = await fetchWithAuth(
    url,
    {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
    navigate
  );

  if (!response.ok) {
    const error = new Error(`Planning API error: ${response.status}`);
    error.status = response.status;
    throw error;
  }

  return response;
}

export async function getPlanningCalendar(
  { from, to, teamId, seasonId } = {},
  navigate
) {
  const search = new URLSearchParams();
  if (from) search.set("from", from);
  if (to) search.set("to", to);
  if (teamId) search.set("teamId", teamId);
  if (seasonId) search.set("seasonId", seasonId);

  const response = await planningFetch(
    `${PLANNING_URL}/calendar?${search.toString()}`,
    { method: "GET" },
    navigate
  );
  const data = await response.json();

  return {
    scope: data.scope ?? data.asociacion ?? null,
    events: data.events ?? data.eventos ?? [],
    matches: data.matches ?? data.partidos ?? [],
  };
}

export function buildPlanningDocument(data) {
  if (!VALID_ENTITY_TYPES.includes(data.tipoEntidad)) {
    throw new Error("Invalid planning entity type");
  }
  if (!data.titulo || !data.fechaInicio) {
    throw new Error("Planning title and start date are required");
  }
  if (!data.teamId || !data.seasonId) {
    throw new Error("Planning events require an authorized team and season");
  }

  return {
    ...data,
    id: data.id ?? window.crypto.randomUUID(),
    partitionKey: data.tipoEntidad,
    creadoEn: data.creadoEn ?? new Date().toISOString(),
    actualizadoEn: new Date().toISOString(),
  };
}

export async function createPlanningEvent(data, navigate) {
  const document = buildPlanningDocument(data);
  const response = await planningFetch(
    `${PLANNING_URL}/events`,
    {
      method: "POST",
      body: JSON.stringify(document),
    },
    navigate
  );
  return response.json();
}

export async function deletePlanningEvent(id, partitionKey, navigate) {
  if (!id || !VALID_ENTITY_TYPES.includes(partitionKey)) {
    throw new Error("Planning event id and partition key are required");
  }

  await planningFetch(
    `${PLANNING_URL}/events/${encodeURIComponent(id)}?partitionKey=${encodeURIComponent(partitionKey)}`,
    { method: "DELETE" },
    navigate
  );
}
